import withReducer from '../../store/withReducer'
import Exports from './container'
import reducer from './module'

export default withReducer('exports', reducer)(Exports)



// WEBPACK FOOTER //
// ./src/legacy/pages/Exports/index.js